export default __webpack_public_path__ + "static/media/66.3e48ed4d.gif";